var _a;
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as actions from '../constants/actionTypes';
var promoCode = handleActions((_a = {},
    _a[actions.setPromoCode.type.REQUEST] = function (_, _a) {
        var payload = _a.payload;
        return payload;
    },
    _a[actions.removePromoCode.type.REQUEST] = function () { return null; },
    _a), null);
export default combineReducers({
    promoCode: promoCode,
});
//# sourceMappingURL=promoCode.js.map